import { t } from '@transifex/native';

import { show } from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create as modelsCreate } from 'pkg/api/models/actions';
import { VideoType } from 'pkg/api/models/video';
import * as sdk from 'pkg/core/sdk';

import { Event, trackEvent, trackedGroup } from 'components/analytics';

import {
	isValidVeoSource,
	isValidYouTubeSource,
} from 'components/video-analytics/source/SourceUrl';

export interface VideoCreatePayload {
	userId?: number;
	groupId?: number;
	externalId?: string;
	thumbnailAttachmentId?: number;

	title: string;
	description?: string;
	duration?: number;
	type?: VideoType;
	private?: boolean;

	uri?: string;
	veoUri?: string;
}

export async function create(
	organizationId: number,
	payload: VideoCreatePayload
): Promise<[Response, models.video.Video, models.APIError?]> {
	if (payload.uri && payload.veoUri) {
		return Promise.resolve([new Response(null, { status: 400 }), null]);
	}

	if (payload.uri) {
		if (!payload.type) {
			if (isValidYouTubeSource(payload.uri)) {
				payload.type = VideoType.YouTube;
			} else {
				payload.type = VideoType.Raw;
			}
		}

		if (isValidVeoSource(payload.uri)) {
			payload.veoUri = payload.uri;
			payload.uri = null;
		}
	}

	const result = await modelsCreate<VideoCreatePayload, models.video.Video>(
		endpoints.Videos.Create(organizationId),
		payload
	);

	// Videos are added by link (YouTube, Vimeo, raw) or from Veo and
	// Wingfield; there is no file upload, so adding one counts as uploaded.
	if (result[0].ok) {
		trackEvent(Event.VideoUploaded, trackedGroup(payload.groupId));
	}

	return result;
}

export async function updateVideo(
	organizationId: number,
	videoId: number,
	payload: any,
	displayFlash = true
): Promise<models.video.Video> {
	const request = await sdk.patch(
		endpoints.Videos.Update(organizationId, videoId),
		{},
		payload
	);
	if (!request.ok) {
		return;
	}

	const result = await request.json();

	if (displayFlash === true) {
		show(
			{
				title: t(`Video updated`),
				message: t(`Successfully updated video`),
			},
			200
		);
	}
	return result;
}
